import { Type } from '@angular/core';
import {
  BaseIconComponent,
  BuildingIconComponent,
  SecureSafeIconComponent,
  Profile2UserIconComponent,
  DocumentTextIconComponent,
  ClipboardTickIconComponent,
} from '@ui-lib';
import { PreRegistrationStepKey } from '@common/interfaces/pre-registration/pre-registration.interface';

export interface PreRegistrationStep {
  /** Stable step key, also used as the TabStateService tab name. */
  key: PreRegistrationStepKey;
  /** Name of the matching form group (null for the review step). */
  formGroupName: string | null;
  /** POEditor key for the step label. */
  labelKey: string;
  /** POEditor key for the "Step N" caption. */
  stepLabelKey: string;
  /** Icon shown in the stepper rail (the app's icon approach). */
  icon: Type<BaseIconComponent>;
}

export const PRE_REGISTRATION_STEPS: PreRegistrationStep[] = [
  {
    key: 'company',
    formGroupName: 'companyForm',
    labelKey: 'pre_registration_step_company_label',
    stepLabelKey: 'pre_registration_step_1_label',
    icon: BuildingIconComponent,
  },
  {
    key: 'cma',
    formGroupName: 'cmaForm',
    labelKey: 'pre_registration_step_cma_label',
    stepLabelKey: 'pre_registration_step_2_label',
    icon: SecureSafeIconComponent,
  },
  {
    key: 'contacts',
    formGroupName: 'contactsForm',
    labelKey: 'pre_registration_step_contacts_label',
    stepLabelKey: 'pre_registration_step_3_label',
    icon: Profile2UserIconComponent,
  },
  {
    key: 'nda',
    formGroupName: 'ndaForm',
    labelKey: 'pre_registration_step_nda_label',
    stepLabelKey: 'pre_registration_step_4_label',
    icon: DocumentTextIconComponent,
  },
  {
    key: 'review',
    formGroupName: null,
    labelKey: 'pre_registration_step_review_label',
    stepLabelKey: 'pre_registration_step_5_label',
    icon: ClipboardTickIconComponent,
  },
];

export const PRE_REGISTRATION_STEP_NAMES = PRE_REGISTRATION_STEPS.map(
  s => s.key
);
